import { render, staticRenderFns } from "./DictionaryEntrySelectorMultLevel.vue?vue&type=template&id=21cafb0f&"
import script from "./DictionaryEntrySelectorMultLevel.vue?vue&type=script&lang=js&"
export * from "./DictionaryEntrySelectorMultLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports